{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Extensia Chrome nu este instalată.",
      "CTA": "Instalează extensia"
    },
    "STATUS": {
      "OFFLINE": "Telefon deconectat",
      "IN_OTHER_TAB": "Telefon conectat în altă filă",
      "CONNECTING": "Se conectează...",
      "DISCONNECTING": "Se deconectează...",
      "ONLINE": "Telefon online",
      "DIALING": "Se apelează",
      "TRANSFERRING": "Se transferă...",
      "CONSULTING": "În convorbire cu agentul",
      "CALLER_ON_HOLD": "Apelantul este în așteptare",
      "BUSY": "Ocupat",
      "DND": "DND",
      "UNAVAILABLE": "Indisponibil",
      "REJECTED": "Apel respins",
      "CALL_FAILED": "Apel eșuat"
    },
    "QUEUES": {
      "MORE": "Mai multe cozi"
    },
    "TABS": {
      "PHONE": "Telefon",
      "SMS": "SMS",
      "HISTORY": "Istoric"
    },
    "HISTORY": {
      "OPEN": "Deschide",
      "RECENT": "Recente",
      "MISSED": "Ratate",
      "LOADING": "Se încarcă apelurile...",
      "EMPTY": "Niciun apel",
      "ERROR": "Nu s-au putut încărca apelurile",
      "CALL": "Sună înapoi",
      "CALL_STATUS": {
        "BUTTON": "Setează statusul apelului",
        "TITLE": "Statusul apelului",
        "SEARCH_PLACEHOLDER": "Caută statusuri...",
        "LOADING": "Se încarcă statusurile...",
        "NO_OPTIONS": "Nu există statusuri de apel configurate",
        "NO_MATCH": "Nu s-au găsit statusuri",
        "OPTIONS_ERROR": "Nu s-au putut încărca statusurile",
        "RETRY": "Încearcă din nou",
        "CONFIRM_QUESTION": "Setați statusul „{status}” și rezolvați conversația?",
        "CONFIRM": "Confirmă",
        "BACK": "Înapoi",
        "CANCEL": "Anulează",
        "SAVING": "Se salvează...",
        "SAVE_ERROR": "Nu s-a putut salva statusul",
        "RESOLVE_ERROR": "Statusul a fost salvat, dar conversația nu a putut fi rezolvată"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Număr de telefon, ex. +421903000000",
      "BODY_PLACEHOLDER": "Scrieți mesajul...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Trimite SMS",
      "SENDING": "Se trimite...",
      "SENT": "SMS trimis",
      "LOADING": "Se încarcă căsuțele SMS...",
      "NO_INBOX": "Acest cont nu are o căsuță SMS, deci SMS-ul nu poate fi trimis.",
      "INVALID_NUMBER": "Introduceți numărul în format internațional, inclusiv + de la început.",
      "ERROR": "SMS-ul nu a putut fi trimis. Vă rugăm să încercați din nou."
    },
    "ACTIONS": {
      "CONNECT": "Conectează",
      "GO_TO_TAB": "Mergi la fila respectivă",
      "DISCONNECT": "Deconectează",
      "ANSWER": "Răspunde",
      "HANGUP": "Închide",
      "HOLD": "Pune în așteptare",
      "MUTE": "Dezactivează microfonul",
      "SILENCE": "Oprește sunetul",
      "TRANSFER": "Transferă",
      "COMPLETE_TRANSFER": "Finalizează transferul",
      "RETURN_TO_CALLER": "Înapoi la apelant",
      "CANCEL_TRANSFER": "Anulează transferul",
      "DIALPAD": "Afișează tastatura",
      "OPEN_CONVERSATION": "Deschide conversația"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Apel primit",
      "INCOMING_CALL_FROM": "Apel primit de la {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Apel primit de la {number}",
      "ANSWER": "Răspunde",
      "DECLINE": "Respinge"
    },
    "TRANSFER": {
      "TITLE": "Transferă apelul",
      "PLACEHOLDER": "Introduceți numărul destinației transferului...",
      "SEARCH_PLACEHOLDER": "Caută agenți...",
      "TARGET_PLACEHOLDER": "Destinația transferului selectată",
      "CONFIRM": "Transferă",
      "MODE_DIRECT": "Transferă acum",
      "MODE_CONSULT": "Sună mai întâi agentul",
      "CANCEL": "Anulează"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Sigur doriți să luați o pauză pentru toate cozile de așteptare?",
      "CONFIRM_READY": "Sigur doriți să reveniți la starea „pregătit” pentru toate cozile de așteptare?",
      "CONFIRM_BREAK_QUEUE": "Sigur doriți să vă deconectați de la coada {queue}?",
      "CONFIRM_READY_QUEUE": "Sigur doriți să vă conectați la coada {queue}?",
      "LOGIN_TO_QUEUE": "Conectare",
      "LOGOUT_FROM_QUEUE": "Deconectare",
      "LOGIN_TO_ALL_QUEUES": "Conectare la toate cozile",
      "LOGOUT_FROM_ALL_QUEUES": "Deconectare de la toate cozile",
      "OPTION_LOGOUT": "Deconectare",
      "OPTION_BREAK": "Pauză",
      "OPTION_LUNCH": "Prânz",
      "OPTION_AWAY": "Absent",
      "OPTION_DO_NOT_DISTURB": "Nu deranja",
      "OPTION_BUSINESS_TRIP": "Deplasare",
      "CONFIRM": "Confirmă",
      "CANCEL": "Anulează"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Fără conexiune la sistemul telefonic",
      "MESSAGE": "Se pare că conexiunea ta la internet nu funcționează. Te rugăm să o verifici și să încerci din nou.",
      "CREDENTIALS_TITLE": "Sistemul telefonic a respins datele tale de autentificare",
      "CREDENTIALS_MESSAGE": "Sistemul telefonic a refuzat numele de utilizator sau parola salvate în profilul tău. Verifică-le în Setări profil sau întreabă administratorul.",
      "CONFIGURATION_TITLE": "Setările telefonului nu sunt valide",
      "CONFIGURATION_MESSAGE": "Numele de utilizator SIP sau adresa serverului nu are un format valid, așa că telefonul nu se poate conecta. Corectează asta în Setări profil.",
      "NETWORK_SHORT": "Fără conexiune",
      "CREDENTIALS_SHORT": "Autentificare respinsă",
      "CONFIGURATION_SHORT": "Setări telefon nevalide",
      "RETRY": "Încearcă din nou",
      "DISMISS": "Anulează"
    },
    "CONNECTION_QUALITY": "Calitatea conexiunii",
    "CONNECTION_QUALITY_EXCELLENT": "Excelentă",
    "CONNECTION_QUALITY_GOOD": "Bună",
    "CONNECTION_QUALITY_FAIR": "Acceptabilă",
    "CONNECTION_QUALITY_POOR": "Slabă",
    "CONNECTION_QUALITY_DISCONNECTED": "Deconectat"
  },
  "DIAL_REDIRECT": {
    "DIALING": "Se apelează {number}… Puteți închide această filă.",
    "NO_NUMBER": "Niciun număr furnizat. Utilizați ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Introduceți numărul de telefon...",
    "ACTIONS": {
      "DIAL": "Apelează numărul",
      "DIAL_FROM": "Alege numărul de pe care suni"
    },
    "DIAL_FROM": {
      "TITLE": "Apelează de pe numărul unei căsuțe"
    },
    "VALIDATION": {
      "REQUIRED": "Numărul de telefon este obligatoriu",
      "INVALID_FORMAT": "Format de număr de telefon invalid"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Setări și testare audio",
    "SELECT_DEVICE": "Selectați un dispozitiv...",
    "SYSTEM_DEFAULT": "Implicit de sistem",
    "SAVED": "Salvat",
    "DISCONNECTED_SUFFIX": "neconectat",
    "DEVICE_DISCONNECTED": "Dispozitivul selectat nu este conectat. Apelurile folosesc dispozitivul implicit de sistem până revine.",
    "MICROPHONE": {
      "TITLE": "Microfon",
      "START_TEST": "Testează microfonul",
      "STOP_TEST": "Oprește testul",
      "LEVEL": "Nivel:",
      "VERDICT": {
        "LISTENING": "Spuneți ceva în microfon…",
        "SILENT": "Nu vă aude nimeni. Verificați dacă microfonul este pornit și dacă este selectat cel corect.",
        "LOW": "Vă aude doar încet. Alegeți alt microfon sau ajustați volumul de intrare în setările sistemului.",
        "GOOD": "Sunet bun — vă aude bine."
      }
    },
    "SPEAKER": {
      "TITLE": "Difuzor",
      "TEST": "Testează difuzorul",
      "TESTING": "Se testează...",
      "VOLUME": "Volum:",
      "USING_DEFAULT": "Ieșirea selectată nu este disponibilă — redat pe dispozitivul implicit de sistem."
    },
    "DONE": "Gata",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Eroare la accesarea microfonului. Vă rugăm să verificați permisiunile.",
      "MICROPHONE_PERMISSION_DENIED": "Accesul la microfon este blocat. Permiteți-l în setările site-ului din browser pentru a utiliza telefonul.",
      "MICROPHONE_SILENT": "Microfonul dumneavoastră nu captează niciun sunet. Verificați setările audio.",
      "EXTENSION_REQUIRED": "Extensia de telefon nu a fost detectată. Instalați-o sau activați-o pentru a folosi microfonul.",
      "SPEAKER_TEST": "Eroare la testarea ieșirii difuzorului."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Deconectat",
    "ONLINE": "Online",
    "BUSY": "Ocupat"
  },
  "QUEUE_STATUS": {
    "READY": "Pregătit",
    "NOT_READY": "Nu acceptă apeluri",
    "WRAP_UP": "Finalizare",
    "BREAK": "Pauză",
    "LUNCH": "Prânz",
    "AWAY": "Absent",
    "DO_NOT_DISTURB": "Nu deranja",
    "BUSINESS_TRIP": "Deplasare",
    "OTHER_CALL": "Alt apel",
    "QUEUE_CALL": "Apel din coadă",
    "OFFLINE": "Deconectat",
    "ONLINE": "Online",
    "NO_ACCESS": "Fără telefon",
    "PARTIALLY_READY": "Parțial pregătit",
    "MIXED": "Mixt",
    "CHAT_ONLINE": "Online (chat)",
    "CHAT_BUSY": "Ocupat (chat)",
    "CHAT_OFFLINE": "Offline (chat)"
  }
}
